//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import ResponsiveImageStrapi from '@/components/modules/ResponsiveImageStrapi'
import Video from '@/components/modules/Video'

export default {
	components: {
		ResponsiveImageStrapi,
		Video,
	},
	props: {
		data: {
			type: Object,
			default: null,
		},
		pagedata: {
			type: Object,
			default: null,
		},
	},
	data() {
		return {
			popup: false,
			slide: '',
		}
	},
	computed: {
		popActive() {
			return this.$store.state.popactive
		},
	},
	methods: {
		togglePopup(imgObj) {
			this.slide = imgObj
			this.popup = true
			this.$store.commit('setPopup', true)
		},
		closePopup() {
			this.slide = ''
			this.$store.commit('setPopup', false)
			this.popup = false
		},
	},
}
